import { PropsWithChildren } from 'react';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';
import { rgba } from 'polished';

import { Paragraph, Subheading } from './Text';

const Card = styled(Box)<{ error?: boolean }>`
	border: 1px solid
		${(props) => (props.error ? props.theme.colors.red : props.theme.colors.lightBlue)};
	box-shadow: 0px 0px 0px 2px
		${(props) => rgba(props.error ? props.theme.colors.red : props.theme.colors.lightBlue, 0.25)};
	border-radius: 5px;
`;

const Status = styled(Box)<{ error?: boolean }>`
	flex-grow: 0;
	flex-shrink: 0;
	border-radius: 4px;

	background: ${(props) =>
		rgba(props.error ? props.theme.colors.red : props.theme.colors.green, 0.25)};
	color: ${(props) => (props.error ? props.theme.colors.red : props.theme.colors.greenDark)};
`;

export function FormCard(
	props: PropsWithChildren<{
		title: string;
		description: string;
		error?: boolean;
		status?: string;
	}>,
) {
	return (
		<Card mb={3} p={3} error={props.error}>
			<Flex alignItems="flex-start">
				<Box flexGrow={1} flexShrink={1}>
					<Subheading>{props.title}</Subheading>
					<Paragraph>{props.description}</Paragraph>
				</Box>
				{props.status && (
					<Status error={props.error} px={3} py={2} ml={2}>
						{props.status}
					</Status>
				)}
			</Flex>
			<Box mt={2}>{props.children}</Box>
		</Card>
	);
}
